import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivityTypologyStyle, appRoutes } from '@tekman/onmat/constants';
import { SessionEvaluationInstrument, StepActivity } from '@tekman/onmat/models';
import { UserService } from '@tekman/onmat/service/generic';
import { CategoryMapperService, FeaturitWrapperService } from '@tekman/onmat/service/onmat';
import { FeaturitEventActivity } from '@tekman/shared/models';

@Component({
  selector: 'task-item',
  templateUrl: './task-item.component.html',
  styleUrls: ['./task-item.component.scss'],
})
export class TaskItemComponent implements OnInit {
  @Input() activity: StepActivity;
  @Input() extraActivities: boolean;
  @Input() stepId: string;
  @Input() stepTitle: string;
  @Input() disabled: boolean;
  isTeacher: boolean = this.userService.isTeacher();
  tipologyStyle: typeof ActivityTypologyStyle = ActivityTypologyStyle;
  hasBorder: boolean;
  categoryMapper: string;
  hasHover: boolean;

  constructor(
    public readonly categoryMapperService: CategoryMapperService,
    private readonly _router: Router,
    private readonly userService: UserService,
    private readonly featuritService: FeaturitWrapperService
  ) {}

  ngOnInit() {
    this.hasBorder = !this.activity?.resourceUrl && this.activity?.categoryName && !this.activity?.link;
    this.categoryMapper = this.categoryMapperService.getZeroCategoryStyle(
      this.activity?.typologyStyle || this.activity?.style,
      this.activity?.isHidden,
      this.isTeacher
    );
    this.hasHover =
      this.activity?.typologyName !== 'master-class' &&
      !this.disabled &&
      (!this.activity?.isHidden || (this.activity?.isHidden && this.isTeacher));
  }

  handleClickStep(activity: StepActivity, disabled: boolean): void {
    if (disabled) return;
    if (activity.resourceUrl) {
      this.track(activity, 'itineraries');
      window.open(activity.resourceUrl, '_blank');
      return;
    }
    if (activity.solutionaryUrl) {
      this.track(activity, 'itineraries');
      window.open(activity.solutionaryUrl, '_blank');
      return;
    }
    this._router.navigate([appRoutes.activities, activity.id, 'exercise']);
  }

  handleClickInstrument(activity: SessionEvaluationInstrument): void {
    const solutionaryLink = activity['solutionaryLink'] ?? activity['solutionaryUrl'];
    if (solutionaryLink) {
      window.open(solutionaryLink, '_blank');
      return;
    } else if (activity['link']) {
      this.track(activity, 'itineraries');
      window.open(activity['link'], '_blank');
      return;
    }
    if (
      activity?.resourceUrl &&
      (activity?.typologyStyle === 'recurso_teorico' ||
        activity?.typologyStyle === this.tipologyStyle.VIDEO_ACTIVITY ||
        activity.typologyStyle === 'ejercicio' ||
        activity.typologyStyle === 'prueba')
    ) {
      this.track(activity, 'itineraries');
      window.open(activity?.resourceUrl, '_blank');
      return;
    }
    const exerciseId = activity?.exerciseId ? activity.exerciseId : '';
    this._router.navigate([appRoutes.activities, activity.id, 'exercise', exerciseId]);
  }

  track(currentActivity: StepActivity | SessionEvaluationInstrument, ui_path: string) {
    const trackingProps: FeaturitEventActivity<string> = new FeaturitEventActivity({
      ui_path: ui_path,
      step_id: this.stepId,
      step_title: this.stepTitle,
      activity_id: currentActivity?.id,
      activity_title: currentActivity?.title,
      activity_typology: this.categoryMapperService.getCategory(currentActivity?.typologyStyle),
      activity_subtypology: currentActivity?.typologyStyle,
    });
    this.featuritService.track(this.featuritService.eventKeys.activityDownload, trackingProps);
  }

  isTypeOfActivity(
    activity: StepActivity | SessionEvaluationInstrument | Array<SessionEvaluationInstrument> | Array<StepActivity>
  ): boolean {
    return !Array.isArray(activity);
  }

  protected readonly ActivityTypologyStyle = ActivityTypologyStyle;
}
